// The words are saved as they are typed, per user, so navigation, a reload
// or a closed tab never loses them. Images are not kept (too large); the
// panel says so when it restores a draft that had some.
const key = (userId) => `crm_capture_draft_v1:${userId || 'anon'}`;

export function loadDraft(userId) {
  try {
    const raw = localStorage.getItem(key(userId));
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed.text === 'string' ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function saveDraft(userId, draft) {
  try {
    localStorage.setItem(key(userId), JSON.stringify({ ...draft, updatedAt: Date.now() }));
  } catch (e) { /* storage unavailable — the words still live in the field */ }
}

export function clearDraft(userId) {
  try {
    localStorage.removeItem(key(userId));
  } catch (e) { /* nothing to clear */ }
}
